import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ReactSVG } from "react-svg";

class Accordion extends React.Component {

    state = {};

    constructor(props){
      
        super(props);

        this.header = (props.header) ? props.header : '';
        this.content = (props.content) ? props.content : '';
        this.toggleOnHeaderClick = (props.togleOnHeaderClick) ? true : false;

        this.state.id = props.id;
        this.state.isOpen = false;
        
    }

    setExpanded(set_to)
    { 
        this.setState({isOpen:set_to});
    }

    render(){
        return (
            <li>
                <motion.span
                    className={this.state.isOpen ? "ac_open" : ""}
                    initial={false}
                    animate={{ color: this.state.isOpen ? "#e23000" : "#fff" }}
                >
                    {this.header}
                    {this.toggleOnHeaderClick ? <span className="header_toggle_on_click" onClick={() => this.setExpanded(this.state.isOpen ? false : this.state.id)}></span> : ''}
                    <span className="menu_indicator" onClick={() => this.setExpanded(this.state.isOpen ? false : this.state.id)}><ReactSVG className='scissors_1' src='assets/images/plus_symbol.svg' /> <ReactSVG className='scissors_2' src='assets/images/minus_symbol.svg' /></span>
                </motion.span>

                <AnimatePresence initial={false}>

                    {this.state.isOpen && (
    
                        <motion.ul
                            key="content"
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            className="accordions_cont"
                            variants={{
                                open: { opacity: 1, height: "auto", paddingTop: 10 },
                                collapsed: { opacity: 0, height: 0, paddingTop: 0 } 
                            }}
                            transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                        >

                            {this.content}

                        </motion.ul>
                    )}
                </AnimatePresence>
            </li>
        );
    }
    
};

export default Accordion;
